<template>
     <button class="custom-btn" :class="[customClass, disabled ? 'disabled': '', customLabel == '' ? 'svg-only' : '']" type="button" :id="customId" @click="handleClick">
        {{customLabel}}
		<i class="svg" :class=" svg " :alt="svg ? svg : svgAlt" v-if="svg"></i>
        <span class="sr-only" v-if="srOnlyLabel">{{srOnlyLabel}}</span>
    </button>
</template>

<script>
import bus from '@/js/event-bus.js';
export default {
    name: 'v-button',
    props: {
        customId: {
            type: String
        },
        customClass: {
            type: String,
            default: 'btn-primary'
        },
        srOnlyLabel: {
            type: String,
            default: ''
        },
        customLabel: {
            type: String,
            default: 'Button',
            required: true
        },
        svg: {
            type: String
        },
        svgAlt: {
            type: String
        },
        disabled: {
            type: Boolean
        }
    },
    methods: {
        handleClick (e) {
            bus.$emit('click', e);
        }
    }
};
</script>

<style lang="scss">
.custom-btn {
    display: inline-block;
    padding: 3px 8px;
    background-color: #fff;
    color: $grey;
    border: none;
    border-radius: 3px;
    font-size: 14px;
    font-weight: 500;
    font-family: $title-font-family;
    text-transform: capitalize;
    transition: 0.3s;
    vertical-align: middle;

    svg {
        transition: 0.3s;
    }

    &:not(.nohover):not(.svg-only):not(.disabled) {
        cursor: pointer;
        &:hover,
        &:focus,
        &:active {
            background-color: $primary;
            color: $white;
            text-decoration: none;
            box-shadow: 0 2px 5px rgba(0, 0, 0, 0.5);
            outline: none;
            svg {
                color: #fff;
            }
        }
    }

    &:disabled,
    &.disabled {
        &:hover,
        &:focus {
            background-color: #fff;
            color: $grey;
            box-shadow: none;
            outline: none;
            svg {
                color: $grey;
            }
        }
    }

    &.svg-only {
        padding: 0;
        background: none;
        cursor: pointer;
        svg {
            width: 18px;
            height: 18px;
        }

        &:hover,
        &.filtered {
            svg {
                color: #fff;
            }
        }

        &:hover,
        &:focus,
        &:active {
            background: none!important;
            box-shadow: none!important;
        }
    }
}

svg {
    position: relative;
    top: -1px;
    width: 12px;
    height: 12px;
    vertical-align: middle;
    transition: 0.3s;
    color: $grey;
}
</style>
